import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.66667 6V2H14V6H8.66667ZM2 8.66667V2H7.33333V8.66667H2ZM8.66667 14V7.33333H14V14H8.66667ZM2 14V10H7.33333V14H2Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDashboard);
export default ForwardRef;
